/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Push_Server_Summary_BodyInputs */

const en_us2_push_server_summary_body = /** @type {(inputs: Push_Server_Summary_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`See how your session went.`)
};

const pt_br2_push_server_summary_body = /** @type {(inputs: Push_Server_Summary_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veja como foi o seu treino.`)
};

const es_419_push_server_summary_body = /** @type {(inputs: Push_Server_Summary_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mira cómo te fue en tu entrenamiento.`)
};

const pt_pt2_push_server_summary_body = /** @type {(inputs: Push_Server_Summary_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vê como correu o teu treino.`)
};

const fr_fr2_push_server_summary_body = /** @type {(inputs: Push_Server_Summary_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Regarde comment s'est passée ta séance.`)
};

const de_de2_push_server_summary_body = /** @type {(inputs: Push_Server_Summary_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sieh dir an, wie deine Einheit gelaufen ist.`)
};

const it_it2_push_server_summary_body = /** @type {(inputs: Push_Server_Summary_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guarda com'è andato il tuo allenamento.`)
};

/**
* | output |
* | --- |
* | "See how your session went." |
*
* @param {Push_Server_Summary_BodyInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const push_server_summary_body = /** @type {((inputs?: Push_Server_Summary_BodyInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Push_Server_Summary_BodyInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_push_server_summary_body(inputs)
	if (locale === "es-419") return es_419_push_server_summary_body(inputs)
	if (locale === "pt-PT") return pt_pt2_push_server_summary_body(inputs)
	if (locale === "fr-FR") return fr_fr2_push_server_summary_body(inputs)
	if (locale === "de-DE") return de_de2_push_server_summary_body(inputs)
	if (locale === "it-IT") return it_it2_push_server_summary_body(inputs)
	return en_us2_push_server_summary_body(inputs)
});
export { push_server_summary_body as "push-server.summary_body" }